/**
 * captcha.js
 *
 * @Author: jruif
 * @Date: 2018/7/13 下午6:46
 */
const types = {
  null: '未知类型',
  article: '文章',
  video: '视频',
  gallery: '图集',
};
const captcha = (
  { captchaId, element, mode = 'float', width = 200 },
  { onReady, done, onLoad, fail },
) => {
  const { initNECaptcha, requestAnimationFrame } = window;
  if (initNECaptcha) {
    requestAnimationFrame(() =>
      initNECaptcha(
        {
          captchaId,
          element,
          mode,
          width,
          onReady: instance => {
            // 验证码一切准备就绪，此时可正常使用验证码的相关功能
            onReady && onReady();
          },
          onVerify: (err, data) => {
            /**
             * 第一个参数是err（Error的实例），验证失败才有err对象
             * 第二个参数是data对象，验证成功后的相关信息，data数据结构为key-value，如下：
             * {
             *   validate: 'xxxxx' // 二次验证信息
             * }
             */
            if (err !== null) {
              fail && fail(err);
            } else if (data !== undefined) {
              done && done(data);
            }
          },
        },
        // onLoad
        instance => {
          // 初始化成功
          onLoad && onLoad(instance);
        },
        // onError
        error => {
          // 验证码初始化失败处理逻辑，例如：提示用户点击按钮重新初始化
          fail && fail(error);
        },
      ),
    );
  }
};

export default captcha;
